// extracted by mini-css-extract-plugin
module.exports = {"button":"_025a50318d--button--F0p8Y"};